/* eslint-disable
    func-names,
    max-len,
    no-multi-assign,
    no-param-reassign,
    no-shadow,
    no-unused-vars,
*/
// TODO: This file was created by bulk-decaffeinate.
// Fix any style issues and re-enable lint.
/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * DS206: Consider reworking classes to avoid initClass
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */
const _ = require('lodash');

const deps = ['ViewModel', '_'];
const factory = function (ViewModel, _) {
  let ConversationVM;
  return (ConversationVM = (function () {
    ConversationVM = class ConversationVM extends ViewModel {
      static initClass() {
        this.prototype.$idName = 'id';
        this.prototype.id = null;
        this.prototype.attachedTo = null;
        this.prototype.commentsEarly = [];
        this.prototype.commentsCollapsed = [];
        this.prototype.commentsRecent = [];

        // store yet unposted comments for this conversation
        this.prototype.newComment = '';
      }

      $listenTransformFn(conversation) {
        if (conversation.comments.length > 0) {
          for (const comment of conversation.comments) {
            comment.body = _.unescape(comment.body);
          }

          // Split up the data so that it is collapsible in the middle.
          const numPreCollapse = 1; // amount of comments before collapse
          const numPostCollapse = 2; // amount of comments after collapse

          conversation.commentsEarly = conversation.comments.slice(0, numPreCollapse);
          let remainderComments = _.difference(conversation.comments, conversation.commentsEarly);
          conversation.commentsRecent = remainderComments.slice(-numPostCollapse);
          conversation.commentsCollapsed = remainderComments = _.difference(
            remainderComments,
            conversation.commentsRecent,
          );
        }

        return conversation;
      }
    };
    ConversationVM.initClass();
    return ConversationVM;
  })());
};

factory.$inject = deps;

const moduleDeps = [require('data/util').name, require('data/user').name];

module.exports = angular
  .module('bench.data.viewmodel.conversation', moduleDeps)
  .factory('ConversationVM', factory);
